const Config = {
	DATASET_OPTIONS: {
		borderWidth: 0,
		hoverBorderWidth: 0,
		pointBackgroundColor: "var(--py-primary-5)",
	},
	EXPORT_WIDTH: 1920,
	EXPORT_HEIGHT: 1080,
	DEFAULT_RANGE_OPTION: "TOP_25",
};

export default Config;
